// src/components/CarForm.jsx
import React from "react";
import PropTypes from "prop-types";
import useFormSubmit from "../utilis/hook/useFormSubmit";

const CarForm = ({
  formConfig,
  apiEndpoint,
  task,
  isMobile,
  submit = "Invia",
}) => {
  // Collegamento al custom hook
  const {
    formData,
    sending,
    resultMessage,
    handleChange,
    handleSubmit,
  } = useFormSubmit(apiEndpoint, task);

  return (
    <form onSubmit={handleSubmit} className="row g-3">
      {formConfig.map((step, sIdx) =>
        step.fields.map((field, fIdx) => {
          const {
            tag,
            type,
            name,
            class: wrapperClass,
            icon,
            placeholder,
            required,
            options,
          } = field;

          const commonProps = {
            name,
            placeholder,
            required,
            onChange: handleChange,
            value: formData[name] || "",
          };

            return (
              <div  id="form" key={fIdx} className={wrapperClass}>
                  <div className="input-group">
                    {tag === "input" && (
                      <input type={type} className="form-control" {...commonProps} />
                    )}
                    {tag === "textarea" && (
                      <textarea rows={4} className="form-control" {...commonProps} />
                    )}
                    {tag === "select" && (
                      <select className="form-select" {...commonProps}>
                        <option value="">{placeholder}</option>
                        {Array.isArray(options) &&
                          options.map((opt) => (
                            <option key={opt.index} value={opt.index}>
                              {opt.label}
                            </option>
                          ))}
                      </select>
                    )}

                    {icon && (
                      <span className="input-group-text">
                        <i className={icon} aria-hidden="true" />
                      </span>
                    )}
                  </div>
                </div>

          );
        })
      )}

      <div className="col-12 d-flex align-items-center justify-content-center">
        <button
          type="submit"
          className={` btn btn btn-sm btn btn-three ${isMobile ? "w-100" : ""}`}
          disabled={sending}
        >
          {sending ? "Invio..." : submit}
        </button>
      </div>

      {resultMessage && (
        <div
          className={`alert ${
            resultMessage.type === "success"
              ? "alert-success"
              : "alert-danger"
          } mt-3 col-12`}
        >
          {resultMessage.text}
        </div>
      )}
    </form>
  );
};

CarForm.propTypes = {
  formConfig:  PropTypes.array.isRequired,
  apiEndpoint: PropTypes.string.isRequired,
  task:        PropTypes.string,
  isMobile:    PropTypes.bool,
  submit:      PropTypes.string,
};

export default CarForm;
